import React, { Component } from 'react';
import { Grid,Row,Col,Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import './Howto.css';
import choose from './choose.svg';
import messages from './messages.svg';
import send from './send.svg';
import {Helmet} from 'react-helmet'

class Howto extends Component {
  render() {
    document.title = "Greeting Cards - NaleyCards Malaysia"
    return (
      <React.Fragment>
      <Helmet>
        <link rel="canonical" href="https://www.naleycards.com" />
        <meta name="description" content="Choose a greeting card, write wishes, we mail for you. Personalized greeting cards for someone you care about."></meta>
      </Helmet>
<Grid>
  <Row>
    <Col xs={12} sm={12} md={12} lg={12}>
      <div className="how-subject">
        We Mail Your Love
      </div>
    </Col>
  </Row>
  <Row>
    <Col xs={12} sm={4} md={4} lg={4}>
      <div className="how">
        <Link to="/cards"><img src={choose} height="128" alt="Choose a card" />
        <div className="how-desc">Choose a card</div></Link>
      </div>
    </Col>
    <Col xs={12} sm={4} md={4} lg={4}>
    <div className="how">
      <img src={messages} height="128" alt="Write wishes" />
      <div className="how-desc">Write wishes</div>
    </div>
    </Col>
    <Col xs={12} sm={4} md={4} lg={4}>
      <div className="how">
        <img src={send} height="128" alt="We mail for you" />
        <div className="how-desc">We mail for you</div>
      </div>
    </Col>
  </Row>
  <Row>
    <Col xs={2} sm={4} md={4} lg={4}>
    </Col>
    <Col xs={8} sm={4} md={4} lg={4}>
      <span className="nl-button">
        <Link to="/cards"><Button block bsSize="lg">Choose a card</Button></Link>
      </span>
    </Col>
    <Col xs={2} sm={4} md={4} lg={4}>
    </Col>
  </Row>
</Grid>
</React.Fragment>
    );
  }
}

export default Howto;
